import styles from "./navbar.module.css";

const navbarStyles = {
    container: `w-full container py-5 pb-[6px] ${styles.container_nav}`,
    wrapper: `flex justify-between items-center w-full relative`,
    logo: `w-[65px] max-w-full h-auto
           md:w-[95px] ${styles.logo}
    `,
    heading: `hidden text-primaryHeading text-[26px] font-semibold leading-[20px]
              md:block
    `,
    side_btns_wrpr: `flex items-center gap-2 
                    md:gap-5
    `,
    login_btn:  `${styles.login_btn}`
}

const cartStyles = {
    container: ` w-[35px] h-[35px] rounded-full disabled:bg-[#6c757d] bg-primaryHeading flex items-center justify-center relative ${styles.container} 
                 md:w-[45px] md:h-[45px]
    `,
    carticon: `!text-[16px] md:!text-[20px] ${styles.carticon}`,
    total_count_badge: `absolute top-1 right-3 transform translate-x-1/2 -translate-y-1/2 bg-white text-black text-[9px] font-[700] rounded-full w-4 h-4 flex items-center justify-center
                        md:text-[11px] md:w-[20px] md:h-[20px] md:top-[5px]  md:left-[10px] ${styles.total_count_badge}
    `,
}

export { navbarStyles, cartStyles }